import { API_COMMON_ERROR } from '@savgroup-front-common/constants';
import { BackError } from '@savgroup-front-common/types';

import {
  INVALID_WEBSITE_ERROR_MESSAGE_PATTERN,
  WEBSITE_ERROR_FIELD,
} from '../OnboardingForm.constants';

export function getIsInvalidWebsiteError(
  error: BackError | undefined,
): boolean {
  if (!error) {
    return false;
  }

  if (error.code !== API_COMMON_ERROR.DATA_HAS_INVALID_VALUE) {
    return false;
  }

  if (error.field?.toLowerCase() === WEBSITE_ERROR_FIELD) {
    return true;
  }

  return INVALID_WEBSITE_ERROR_MESSAGE_PATTERN.test(error.message ?? '');
}
